module.exports = __webpack_public_path__ + "staticfr/media/Dt9.f8899ad6.jpg";